import { publishEvent } from '@/analyticsService';

export const publishRequestDemoClick = () => {
  publishEvent(
    {
      component: 'LOGIN_PAGE',
      action: 'CLICK_REQUEST_DEMO_LINK',
    },
    { link: 'https://nyshex.com/how-to-start' }
  );
};

const publishLoginPageEvent = (
  action: string,
  eventProperties: Record<string, unknown>,
  userId?: string
) => {
  const eventType = {
    component: 'LOGIN_PAGE',
    action,
  };
  publishEvent(eventType, eventProperties, userId);
};

export const publishViewPage = (eventProperties: Record<string, unknown>) => {
  publishLoginPageEvent('VIEW_PAGE', eventProperties);
};

export const publishSubmitLoginForm = (
  eventProperties: Record<string, unknown>
) => {
  publishLoginPageEvent('SUBMIT_LOGIN_FORM', eventProperties);
};

export const publishReceiveLoginResult = (
  eventProperties: Record<string, unknown>,
  userId?: string
) => {
  publishLoginPageEvent('RECEIVE_LOGIN_RESULT', eventProperties, userId);
};

export const publishSSOLoginEvent = (
  eventProperties: Record<string, unknown>,
  userId?: string
) => {
  publishLoginPageEvent('SSO_LOGIN', eventProperties, userId);
};
